/**
 * SetAttribute is a helper function. This will combine two strings together
 * when the prefix attribute is available. In the scenario there is no prefix
 * attribute, it returns undefined.
 */
export const setAttribute = (prefix: string | undefined, attribute: string): string | undefined => (prefix !== undefined ? `${prefix}.${attribute}` : undefined);
